import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return combineLatest([
      this.authService.isLoading$,
      this.authService.isAuthenticated$
    ]).pipe(
      filter(([isLoading]) => !isLoading),
      take(1),
      map(([, isAuthenticated]) => {
        if (isAuthenticated) {
          return true;
        }
        // Store the attempted URL for redirecting after login
        return this.router.createUrlTree(['/login'], {
          queryParams: { returnUrl: state.url }
        });
      })
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return combineLatest([
      this.authService.isLoading$,
      this.authService.isAuthenticated$
    ]).pipe(
      filter(([isLoading]) => !isLoading),
      take(1),
      map(([, isAuthenticated]) => {
        if (!isAuthenticated) {
          return true;
        }
        // Already logged in, redirect to home
        return this.router.createUrlTree(['/']);
      })
    );
  }
}
